import * as Yup from "yup";

export const supplierPartyInitialValues = {
  name: "",
  mobile: "",
  whatsapp: "",
  email_id: "",
  gst_number: "",

  city: "",
  state: "",
  pin: "",
  address: "",

  opening: 0,

  is_active: true,
  is_type: "supplier",
};


export const supplierPartyValidationSchema = Yup.object().shape({

  name: Yup.string()
    .trim()
    .min(2, "Name must be at least 2 characters")
    .max(255, "Max 255 characters allowed")
    .required("Name is required"),

  mobile: Yup.string()
    .matches(/^[0-9]{10}$/, "Enter a valid 10 digit mobile number")
    .required("Mobile number is required"),

  // whatsapp: Yup.string()
  //   .nullable()
  //   .notRequired()
  //   .matches(/^[0-9]{10}$/, "Enter a valid 10 digit WhatsApp number")
  //   .test(
  //     "empty-or-valid",
  //     "Enter a valid 10 digit WhatsApp number",
  //     value => !value || /^[0-9]{10}$/.test(value)
  //   ),

  email_id: Yup.string()
    .trim()
    .email("Enter a valid email")
    .required("Email is required"),

  // gst_number: Yup.string()
  //   .nullable()
  //   .notRequired()
  //   .matches(
  //     /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
  //     "Enter a valid GST number"
  //   )
  //   .test(
  //     "empty-or-valid-gst",
  //     "Enter a valid GST number",
  //     value => !value || /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(value)
  //   ),

  // city: Yup.string()
  //   .trim()
  //   .required("City is required"),

  // state: Yup.string()
  //   .trim()
  //   .required("State is required"),

  // pin: Yup.string()
  //   .matches(/^[0-9]{6}$/, "Enter valid 6 digit PIN code")
  //   .required("PIN code is required"),

  // address: Yup.string()
  //   .trim()
  //   .min(3, "Address must be at least 3 characters")
  //   .required("Address is required"),

  // opening: Yup.number()
  //   .typeError("Opening must be a number")
  //   .min(0, "Opening cannot be negative")
  //   .required("Opening is required"),

  // is_active: Yup.boolean(),

  // is_type: Yup.string()
  //   .oneOf(["supplier", "party", "both"], "Invalid type")
  //   .required("Type is required"),
});